import React from 'react';
import PlainCRUD, { defaultFields } from 'components/PlainCRUD';
import {
  deleteTipoConsiderado,
  getTiposDeConsiderados,
  patchTipoConsiderado,
  postTipoConsiderado,
} from 'api/cuentaunicasir/tipoDeConsiderado';

// eslint-disable-next-line react/prop-types
const TipoDeConsiderado = ({ permission }) => (
  <PlainCRUD
    title="Tipo de Considerado"
    permission={permission}
    get={getTiposDeConsiderados}
    post={postTipoConsiderado}
    patch={patchTipoConsiderado}
    delete={deleteTipoConsiderado}
    withoutState
    fields={[
      defaultFields.descripcion,
    ]}
  />
);

export default TipoDeConsiderado;
